import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import '@/assets/css/onboarding.css';
import { setActiveOnboardingDriver } from '@/store/onboarding-store';
import i18n from '../i18n';
import { waitForAllElements } from './waitForDomElements';

const startUserInfoGuide = (options = {}) => {
  const {
    hasSystemDefaultName = false,
    hasMissingPhoneNumber = false,
    onFinish = () => {},
  } = options;

  const steps = [];

  if (hasSystemDefaultName) {
    steps.push({
      element: '.full-name-input',
      popover: {
        title: i18n.t('onboarding.user_info.guide.name_title'),
        description: i18n.t('onboarding.user_info.guide.name_description'),
      },
    });
  }

  if (hasMissingPhoneNumber) {
    steps.push({
      element: '.phone-number-input',
      popover: {
        title: i18n.t('onboarding.user_info.guide.phone_title'),
        description: i18n.t('onboarding.user_info.guide.phone_description'),
      },
    });
  }

  if (!steps.length) {
    return false;
  }

  const requiredSelectors = steps.map((step) => step.element);
  return waitForAllElements(requiredSelectors)
    .then((allFound) => {
      if (!allFound) {
        return false;
      }

      let isCompleted = false;

      const onboardingDriver = driver({
        showProgress: true,
        allowClose: false,
        showButtons: ['previous', 'next'],
        prevBtnText: i18n.t('onboarding.prev'),
        nextBtnText: i18n.t('onboarding.next'),
        doneBtnText: i18n.t('onboarding.done'),
        steps: steps.map((step, index) => {
          if (index === steps.length - 1) {
            return {
              ...step,
              popover: {
                ...step.popover,
                onNextClick: () => {
                  isCompleted = true;
                  onboardingDriver.destroy();
                },
              },
            };
          }
          return step;
        }),
        onDestroyed: () => {
          if (isCompleted) {
            onFinish();
          } else if (options.onDeactivated) {
            options.onDeactivated();
          }
        },
      });

      setActiveOnboardingDriver(onboardingDriver);
      onboardingDriver.drive();

      return true;
    });
};

export { startUserInfoGuide };
export default startUserInfoGuide;
